import { FieldType } from '../common';

import { FillingMethod } from './entity';

export const FILLING_METHOD_TO_TEXT: Record<FillingMethod, string> = {
  [FillingMethod.form]: 'Форма',
  [FillingMethod.import]: 'Импорт',
};

export const FIELD_TYPE_TO_TEXT: Record<FieldType, string> = {
  [FieldType.formula]: 'Формула',
  [FieldType.bool]: 'Логическое',
  [FieldType.int]: 'Число',
  [FieldType.str]: 'Текст',
  [FieldType.datetime]: 'Дата',
  [FieldType.enum]: 'Справочник',
  [FieldType.percent]: 'Проценты',
};
